// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"cd12835e","139":"00fe1022","327":"8c12ecdb","403":"96fd64bf","500":"f265259c","520":"8cb1944f","587":"b3b76ee0","636":"a264f982","757":"b058cf3b","780":"00d376e5","843":"2a7d8c52","973":"99fe4b9c","975":"f4bda7c2"}[chunkId] + ".chunk.js";
};